import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Header = ({ profile }) => {
    const navigate = useNavigate();
    const location = useLocation(); 
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    if (location.pathname === "/txmd5") {
        return null;
    }

    // Hàm đóng menu khi click vào link
    const closeMenu = () => setIsMenuOpen(false);

    return (
        <>
            {/* ================= HEADER CHÍNH ================= */}
            <div 
                className="header" 
                style={{ 
                    position: "relative", display: "flex", alignItems: "center", justifyContent: "space-between", 
                    padding: "10px 15px", minHeight: "55px", backgroundColor: "#60d3b0", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" 
                }}
            >
                {/* NÚT MENU BÊN TRÁI */}
                <div 
                    className="header-left"
                    style={{ display: "flex", alignItems: "center", cursor: "pointer", color: "#246e4f" }}
                    onClick={() => setIsMenuOpen(true)}
                >
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"/>
                    </svg>
                </div>

                {/* LOGO */}
                <div 
                    className="logo" 
                    style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", display: "flex", alignItems: "center", zIndex: 2 }}
                >
                    <Link to="/" style={{ display: "flex" }}>
                        <img alt="Logo" src="/images/logo.png" style={{ height: "40px", objectFit: "contain" }} />
                    </Link>
                </div>
            </div>

            {/* ================= BẢNG MENU (SIDEBAR) ================= */}
            {isMenuOpen && (
                <div 
                    className="menu-overlay"
                    style={{
                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 9999, display: "flex", justifyContent: "flex-end"
                    }}
                    onClick={() => setIsMenuOpen(false)} 
                >
                    <div 
                        className="menu-content"
                        style={{
                            width: "340px", height: "100%", backgroundColor: "#fff", display: "flex", flexDirection: "column",
                            boxShadow: "-2px 0 10px rgba(0,0,0,0.3)", animation: "slideIn 0.3s forwards", overflowY: "auto"
                        }}
                        onClick={(e) => e.stopPropagation()} 
                    >
                        {/* KHU VỰC HEADER CỦA MENU */}
                        <div style={{
                            background: "linear-gradient(180deg, #b3ecd8 0%, #3bb689 100%)",
                            padding: "30px 20px 20px", position: "relative", display: "flex", flexDirection: "column", alignItems: "center"
                        }}>
                            <div 
                                style={{ position: "absolute", top: "10px", right: "15px", color: "white", fontSize: "28px", cursor: "pointer", opacity: 0.8 }}
                                onClick={() => setIsMenuOpen(false)}
                            >×</div>

                            <img 
                                src={profile?.avatar || "https://i.ibb.co/5WDK50Gs/image.png"} 
                                alt="Avatar"
                                style={{ width: "70px", height: "70px", borderRadius: "50%", border: "2px solid #fff", objectFit: "cover", marginBottom: "10px" }}
                            />
                            
                            <h3 style={{ color: "white", margin: "0 0 10px 0", fontSize: "20px", fontWeight: "bold" }}>
                                {profile?.username}
                            </h3>

                            <div style={{ background: "rgba(255,255,255,0.4)", borderRadius: "20px", padding: "4px 15px", display: "flex", alignItems: "center", gap: "10px", minWidth: "150px", justifyContent: "space-between" }}>
                                <div style={{ width: "20px", height: "20px", background: "#d32f2f", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "yellow", fontSize: "12px" }}>★</div>
                                <span style={{ color: "yellow", fontWeight: "bold", fontSize: "16px" }}>{parseFloat(profile?.money || 0).toLocaleString("vi-VN")} VND</span>
                            </div>
                        </div>

                        {/* KHU VỰC NỘI DUNG CHÍNH */}
                        <div style={{ padding: "15px", flex: 1 }}>
                            
                            {/* 3 Nút To */}
                            <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                                <TopButton 
                                    title="Tài khoản" 
                                    href="/profile" 
                                    iconSrc="https://i.ibb.co/mkWyKtn/gemini-svg-3-removebg-preview.png" 
                                    onClick={closeMenu}
                                />
                                <TopButton 
                                    title="Nạp Tiền" 
                                    href="/recharge/bank" 
                                    iconSrc="https://i.ibb.co/pBt63Kkn/gemini-svg-4-removebg-preview.png" 
                                    onClick={closeMenu}
                                />
                                <TopButton 
                                    title="Rút Tiền" 
                                    href="/withdraw" 
                                    iconSrc="https://i.ibb.co/kV74nG5P/gemini-svg-5-removebg-preview.png" 
                                    onClick={closeMenu}
                                />
                            </div>

                            <hr style={{ border: "none", borderTop: "1px solid #1f8a65", opacity: 0.5, marginBottom: "15px" }} />

                            {/* Danh sách các nút dài */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <MenuRow 
                                    title="Lịch sử đặt cược" 
                                    href="/historyplay"
                                    onClick={closeMenu}
                                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="#2d5e4b"><path d="M12 2C8.5 2 4 6 4 11.5c0 2.26 1.15 4.34 3.03 5.48.59.36.97 1.05.97 1.77V22h6v-3.25c0-.72.38-1.41.97-1.77C18.85 15.84 20 13.76 20 11.5 20 6 15.5 2 12 2z"/></svg>} 
                                />
                                
                                <MenuRow 
                                    title="Biến động số dư" 
                                    href="/transaction/history"
                                    onClick={closeMenu}
                                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="#2d5e4b"><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"/></svg>} 
                                />
                                
                                <MenuRow 
                                    title="Lịch sử lãi lỗ" 
                                    href="/history"
                                    onClick={closeMenu}
                                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="#2d5e4b"><path d="M11 2v10h10C20.45 6.36 15.64 1.55 11 2zm2 12c0 4.41-3.59 8-8 8s-8-3.59-8-8 3.59-8 8-8v8h8z"/></svg>} 
                                />
                                
                                <MenuRow 
                                    title="Bảo mật tài khoản" 
                                    href="/password"
                                    onClick={closeMenu}
                                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="#2d5e4b"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>} 
                                />
                                
                                <MenuRow 
                                    title="6789@6789.com" 
                                    href="mailto:6789@6789.com"
                                    onClick={closeMenu}
                                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="#2d5e4b"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>} 
                                />
                                
                                <MenuRow 
                                    title="TẢI 1.1.1.1" 
                                    href="https://1.1.1.1/"
                                    target="_blank"
                                    onClick={closeMenu}
                                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="#2d5e4b"><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49-.12-.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/></svg>} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

// Component cho 3 Nút to - Đã fix routing
const TopButton = ({ title, iconSrc, href, onClick }) => {
    // Phân biệt link ra web ngoài (http/mailto) và link nội bộ react-router
    const isExternal = href?.startsWith("http") || href?.startsWith("mailto");
    
    const Wrapper = isExternal ? 'a' : Link;
    const linkProps = isExternal ? { href } : { to: href };

    return (
        <Wrapper 
            {...linkProps} 
            onClick={onClick}
            style={{ textDecoration: 'none', display: 'flex', flex: 1 }}
        >
            <div style={{
                flex: 1, backgroundColor: "#208f65", color: "#fff", display: "flex", flexDirection: "column",
                alignItems: "center", justifyContent: "center", padding: "12px 5px", borderRadius: "8px",
                cursor: "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.15)", border: "1px solid #1a7553",
                width: "100%", boxSizing: "border-box"
            }}>
                <div style={{ marginBottom: "5px" }}>
                    <img src={iconSrc} alt={title} style={{ width: "28px", height: "28px", objectFit: "contain" }} />
                </div>
                <span style={{ fontSize: "13px", textAlign: "center", lineHeight: "1.2" }}>{title}</span>
            </div>
        </Wrapper>
    );
};

// Component cho các nút Menu dài - Đã fix routing
const MenuRow = ({ title, icon, href, target, onClick }) => {
    const isExternal = href?.startsWith("http") || href?.startsWith("mailto");
    
    const Wrapper = isExternal ? 'a' : Link;
    const linkProps = isExternal 
        ? { href, target, rel: target === "_blank" ? "noopener noreferrer" : undefined } 
        : { to: href };

    return (
        <Wrapper 
            {...linkProps} 
            onClick={onClick}
            style={{ textDecoration: 'none', display: 'block' }}
        >
            <div style={{
                display: "flex", alignItems: "center", padding: "12px 15px", borderRadius: "6px",
                background: "linear-gradient(180deg, #b2ead6 0%, #68c7a3 100%)",
                border: "1px solid #339e78", boxShadow: "0 2px 3px rgba(0,0,0,0.1)",
                cursor: "pointer", color: "#2d5e4b", fontWeight: "500", fontSize: "15px",
                width: "100%", boxSizing: "border-box"
            }}>
                <div style={{ marginRight: "15px", display: "flex", alignItems: "center" }}>
                    {icon}
                </div>
                <span>{title}</span>
            </div>
        </Wrapper>
    );
};

export default Header;